import RouteWithSubRoutes, { BaseRoute } from 'component/RouteWithSubRoutes';
import { getCompanyId, getUserId, getOrgCode } from 'data/storage';
import { getUserInfo, getSSOUserInfo } from 'model/user';
import { getOrderSettings } from 'model/meeting';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';
import Navigation from './component/Navigation';
import styles from './index.module.scss';
import { isSSO } from 'util/crossenv';
import { RootState } from 'model';
import Grayscale from 'lib/grayscalePublishing';

interface IProps {
  routes: BaseRoute[];
}
// 容器组件
const Home: React.FunctionComponent<IProps> = ({ routes }) => {
  const beEmbedded = useSelector((state: RootState) => state.app.beEmbedded);
  const dispatch = useDispatch();
  const companyId = getCompanyId();

  const isCvte =
    companyId.toLowerCase() === '3476991a-6605-4f5b-8f5b-3de65e41b9c7' ||
    companyId.toLowerCase() === '3e30a0f4-b4b8-47f9-95db-144148e8065d' ||
    companyId.toLowerCase() === 'e263353b-5265-4203-9807-6c0fe73c4136' ||
    companyId.toLowerCase() === 'ce7263c2-4b01-4809-8e6b-e1fb0ba3d26d';

  useEffect(() => {
    const userId = getUserId();
    const companyId = getCompanyId();
    const orgCode = getOrgCode();

    if (!userId) return;
    if (isSSO()) {
      dispatch(getSSOUserInfo({ userId, companyId }));
    } else {
      dispatch(getUserInfo(userId));
    }
    /** 获取会议配置 */
    if (companyId) {
      dispatch(getOrderSettings());
    }
    /** 灰发逻辑，如果本地有 orgCode，则设置 cookie 的 orgCode 参数 */
    if (orgCode) {
      Grayscale.set(orgCode);
      Grayscale.checkUpdate();
    }
  }, []);

  useEffect(() => {
    // 嵌入第三方应用时，设置为纯白背景色
    if (beEmbedded && document) {
      document.body.style.backgroundColor = '#ffffff';
    }
  }, [beEmbedded]);

  useEffect(() => {
    const checkElement = () => {
      const difyBox = document.getElementById('dify-chatbot-bubble-button');
      console.log(difyBox, 'DifyChatbot');
      if (difyBox) {
        // 为元素添加属性，例如添加自定义属性
        console.log(companyId.toLowerCase(), 'companyId');
        if (isCvte) {
          difyBox.style.display = 'block';
        } else {
          difyBox.style.display = 'none';
        }
      } else {
        // 如果元素还不存在，设置一个短时间后再次检查
        setTimeout(checkElement, 100);
      }
    };

    checkElement();
  }, []);

  return (
    <div className={beEmbedded ? styles.beEmbeddedWrap : styles.warp}>
      <Navigation />
      <div className={styles.container}>
        <Switch>
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
          ))}
        </Switch>
      </div>
    </div>
  );
};

export default Home;
